import KeyFigure from "./KeyFigure.js";
import ModelFactory from "../ModelFactory.js";

/**
 * This factory is responsible for materializing key figures and their components.
 */
class ComponentNodeFactory extends ModelFactory {
	allClasses() {
		return [KeyFigure];
	}

	materialize(data, context = {}) {
		if (this._getTypeFromJson(data) === "KeyFigureReferenceNode") {
			return context.keyFigures[data.id];
		}
		return super.materialize(data, context);
	}
}

const componentNodeFactory = new ComponentNodeFactory();

export default componentNodeFactory;
